"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var material_1 = require("@angular/material");
var lodash_1 = require("lodash");
var ExpensePayTypeDialogComponent = /** @class */ (function () {
    function ExpensePayTypeDialogComponent(dialogRef) {
        this.dialogRef = dialogRef;
        this.loading = false;
        this.errors = [];
    }
    ExpensePayTypeDialogComponent.prototype.ngOnInit = function () {
        this.expense = lodash_1.cloneDeep(this.expense);
    };
    ExpensePayTypeDialogComponent.prototype.submit = function () {
        this.callback(this.expense);
        this.dialogRef.close();
    };
    return ExpensePayTypeDialogComponent;
}());
exports.ExpensePayTypeDialogComponent = ExpensePayTypeDialogComponent;
